import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-8 my-4 gap-y-5 gap-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_Title, {
        label: _ctx.$t('dexAssessment.component.informationDetailStt')
      }, null, 8, ["label"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.component.noStt'),
          value: _ctx.data.daSttNo
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.component.addressType'),
          value: _ctx.addressType[_ctx.data.daSttRecipientAddressType]
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.component.timeDex'),
          value: _ctx.formatDate(_ctx.data.daDeliveryDexDateLocal)
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.component.route'),
          value: `${_ctx.data.daOriginId} - ${_ctx.data.daDestinationId}`
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.component.productType'),
          value: _ctx.data.daProductType
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.component.dexAttempt'),
          value: _ctx.data.daDeliveryDexAttempt
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.component.slaLimit'),
          value: _ctx.$t(_ctx.data.daSttSla)
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.component.customerDispute'),
          value: _ctx.data.daDisputeCustomer
        }, null, 8, ["label", "value"])
      ])
    ]),
    _: 1
  }))
}